import Menu from './Menu';
import {$body} from '../Constants';

/**
 * Implementation of Menu for MainMenu Navigation
 */
class MainMenu extends Menu {
	onReady() {
		if($(window).width() <= 1200) {
			this.$element.find('ul.level-3').each(function() {
				$(this).css({
					right: $(this).css('left'),
					left: 'auto'
				});
			});
		}
	}
}

export default (new MainMenu($body.find('.menuMain')));